/* Last-seen read cache (PWA polish P4). Stale-while-revalidate for server-data
   pages: a fetcher caches its result on success and returns the cached value
   when the network call fails (offline), so Progress/Leaderboard render last-seen
   content instead of an empty state. User-specific keys are namespaced by uid so
   a shared device never shows another account's data. */
const PREFIX = "byb.cache.";

export function cacheSet(key, value) {
  if (!key) return;
  const k = PREFIX + key;
  let payload;
  try {
    payload = JSON.stringify(value);
    localStorage.setItem(k, payload);
  } catch {
    // Quota: everything in this cache is regenerable from the server, so
    // evict every other cached entry and retry once rather than silently
    // growing forever (one leaderboard blob per season/metric combo, 5000-row
    // trend arrays…) until the outbox starts losing real data.
    try {
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const kk = localStorage.key(i);
        if (kk && kk.startsWith(PREFIX) && kk !== k) localStorage.removeItem(kk);
      }
      localStorage.setItem(k, payload);
    } catch {
      /* still failing (or JSON/state issue) — best-effort */
    }
  }
}

export function cacheGet(key) {
  try {
    const raw = key && localStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : undefined;
  } catch {
    return undefined;
  }
}
